/**
 *
 */
import { get, post, put } from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'

/**
 * 添加分类
 */
export const addCategory = (param) => new Promise((resolve, reject) => {
    post(config.CATEGORY_ADD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);

/**
 * 删除分类
 */
export const deleteCategoryById = (param) => new Promise((resolve, reject) => {
    get(config.CATEGORY_DELETE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);

/**
 * 修改分类
 */
export const updateCategoryById = (param) => new Promise((resolve, reject) => {
    put(config.CATEGORY_UPDATE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);

/**
 * 修改排序
 */
export const updateCategoryOrderKey = (param) => new Promise((resolve, reject) => {
    put(config.CATEGORY_ORDER, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);